import { createAction } from '@ngrx/store';

export const togglePrintMode = createAction('[UI] Toggle print mode');
